
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summit/searching",
      function () {
        return require("private-next-pages/summit/searching.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summit/searching"])
      });
    }
  